import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse, WithdrawalContext } from './withdrawals.entity';

@Injectable({
  providedIn: 'root'
})
export class WithdrawalsService extends AbstractService {
  protected override prefix = '/withdrawals';

  getWithdrawals(): Observable<ApiResponse.Withdrawals> {
    return this.get<ApiResponse.Withdrawals>('/history');
  }

  getMethods(): Observable<ApiResponse.Methods> {
    return this.get<ApiResponse.Methods>('/methods');
  }

  getTokens(): Observable<ApiResponse.Tokens> {
    return this.get<ApiResponse.Tokens>('/crypto/tokens');
  }

  doWithdraw(
    methodId: number,
    amount: number,
    context: Partial<WithdrawalContext>,
    isRefBalance: boolean
  ): Observable<ApiResponse.CreatedWithdrawal> {
    return this.post<ApiResponse.CreatedWithdrawal>(
      `/methods/${ methodId }/create`,
      { amount, context, isRefBalance },
      { throwError: true }
    );
  }

  cancelWithdrawal(id: number): Observable<void> {
    return this.post<void>(`/${ id }/cancel`, {}, { throwError: true });
  }

  getSkinToWithdraw(amount: number): Observable<ApiResponse.SkinToWithdraw> {
    return this.get<ApiResponse.SkinToWithdraw>('/find-skin', { amount }, { throwError: true });
  }
}